import React from 'react';
import FloatingTokenBadge from './FloatingTokenBadge';

const LayoutWrapper = ({ children, title, subtitle, className = "" }) => {
    return (
        <div className={`min-h-screen sm:pt-6 sm:mt-6 lg:pt-1 lg:mt-10 ${className}`}>
            <FloatingTokenBadge />
            <div className="max-w-7xl mx-auto sm:px-1 lg:px-8 sm:py-6 lg:py-1">
                {(title || subtitle) && (
                    <div className="mb-6 sm:mb-8">
                        {title && (
                            <h1 className="text-2xl sm:text-3xl font-bold text-white">
                                {title}
                            </h1>
                        )}
                        {subtitle && (
                            <p className="mt-1 sm:mt-2 text-sm sm:text-base text-gray-300">
                                {subtitle}
                            </p>
                        )}
                    </div>
                )}
                {children}
            </div>
        </div>
    );
};

export default LayoutWrapper;